// See AlertTypeDescriptions.
const AlertType = {
	NONE: "",
	O7D: "O7D",
	O1D: "O1D",
	O2D: "O2D",
	O22H: "O22H",
	ABO: "ABO",
	CAS: "CAS",
	ERI: "ERI",
	LRI: "LRI",
	EEZ: "EEZ",
	ETW: "ETW",
	LTW: "LTW",
	LEZ: "LEZ",
	PCS: "PCS",
	LPO: "LPO",
	MYF: "MYF",
	STS: "STS",
	NBY: "NBY",
	RIM: "RIM",
	DEC: "DEC",
	COF: "COF"
};
// TODO: Not sure where/how to structure this. I'm in a bubble!
AlertType.all = () => {
	return [
		AlertType.O7D,
		AlertType.O1D,
		AlertType.O2D,
		AlertType.O22H,
		AlertType.ABO,
		AlertType.CAS,
		AlertType.ERI,
		AlertType.LRI,
		AlertType.EEZ,
		AlertType.LEZ,
		AlertType.ETW,
		AlertType.LTW,
		AlertType.PCS,
		AlertType.LPO,
		AlertType.MYF,
		AlertType.STS,
		AlertType.NBY,
		AlertType.RIM,
		AlertType.DEC,
		AlertType.COF
	];
};
AlertType.DEFAULT_CATEGORY_NAME = "Default";
export default AlertType;
